import Error from '../model/Error';
import axios from 'axios';

export default class EmployeeDuplicationRepository {
    static duplicate(employeeIds, targetKindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .post('/employee-duplication', { targetKindergartenId, employees: employeeIds })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
